// extracted by mini-css-extract-plugin
export var orderSummary = "_uq-0";
export var showMoreLessButton = "_uq-1";